/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1SsoimageIdVideoMutationRequest,
  DeleteApiV1SsoimageIdVideoMutationResponse,
  DeleteApiV1SsoimageIdVideoPathParams,
  DeleteApiV1SsoimageIdVideo400,
  DeleteApiV1SsoimageIdVideo401,
  DeleteApiV1SsoimageIdVideo404,
  DeleteApiV1SsoimageIdVideo500,
} from "../../types/SSOImageController/DeleteApiV1SsoimageIdVideo.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1SsoimageIdVideo } from "../../clients/SSOImageController/deleteApiV1SsoimageIdVideo.ts";

export const deleteApiV1SsoimageIdVideoMutationKey = () =>
  [{ url: "/api/v1/ssoimage/:id/video" }] as const;

export type DeleteApiV1SsoimageIdVideoMutationKey = ReturnType<
  typeof deleteApiV1SsoimageIdVideoMutationKey
>;

export function deleteApiV1SsoimageIdVideoMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DeleteApiV1SsoimageIdVideoMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = deleteApiV1SsoimageIdVideoMutationKey();
  return mutationOptions<
    DeleteApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageIdVideo400
      | DeleteApiV1SsoimageIdVideo401
      | DeleteApiV1SsoimageIdVideo404
      | DeleteApiV1SsoimageIdVideo500
    >,
    {
      id: DeleteApiV1SsoimageIdVideoPathParams["id"];
      data: DeleteApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return deleteApiV1SsoimageIdVideo(id, data, config);
    },
  });
}

/**
 * @description Remove o arquivo de vídeo do Azure Blob Storage. O blobPath retornado pelo endpoint de upload deve ser informado no corpo da requisição. **(Requer Authorization para autenticação)**
 * @summary Excluir vídeo SSO do storage (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id/video}
 */
export function useDeleteApiV1SsoimageIdVideo<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1SsoimageIdVideoMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1SsoimageIdVideo400
        | DeleteApiV1SsoimageIdVideo401
        | DeleteApiV1SsoimageIdVideo404
        | DeleteApiV1SsoimageIdVideo500
      >,
      {
        id: DeleteApiV1SsoimageIdVideoPathParams["id"];
        data: DeleteApiV1SsoimageIdVideoMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<DeleteApiV1SsoimageIdVideoMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1SsoimageIdVideoMutationKey();

  const baseOptions = deleteApiV1SsoimageIdVideoMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageIdVideo400
      | DeleteApiV1SsoimageIdVideo401
      | DeleteApiV1SsoimageIdVideo404
      | DeleteApiV1SsoimageIdVideo500
    >,
    {
      id: DeleteApiV1SsoimageIdVideoPathParams["id"];
      data: DeleteApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageIdVideo400
      | DeleteApiV1SsoimageIdVideo401
      | DeleteApiV1SsoimageIdVideo404
      | DeleteApiV1SsoimageIdVideo500
    >,
    {
      id: DeleteApiV1SsoimageIdVideoPathParams["id"];
      data: DeleteApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageIdVideo400
      | DeleteApiV1SsoimageIdVideo401
      | DeleteApiV1SsoimageIdVideo404
      | DeleteApiV1SsoimageIdVideo500
    >,
    {
      id: DeleteApiV1SsoimageIdVideoPathParams["id"];
      data: DeleteApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >;
}
